var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page",attrs:{"id":"pro"}},[_c('header',{staticClass:"pageHeader"}),_c('div',{attrs:{"id":"scroller"}},[_c('pre-loader',{attrs:{"color":"#267962","textColor":"#267962"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }